export default __webpack_public_path__ + "static/media/litho-landing-page-img-08.ba1b7c6c.jpg";